import * as R from 'ramda'
import React from 'react'
import { Pagination } from 'antd'
import RequireLogin from '../components/RequireLogin/index'
import { getOrders } from '../api/async/orders'
import { MobileOrderCard, OrderCard } from '../components/OrderCard'
import { endEvent } from '../utils'

class MyOrder extends React.Component {
  state = {
    orders: [],
    showOrders: [],
  }

  componentDidMount() {
    getOrders().then((res) => {
      const orders = res.data.filter(
        (each) => !(endEvent(each.event) && !each.is_paid)
      )
      this.setState({ orders })
      this.setState({ showOrders: orders.slice(0, 5) })
    })

    document.title = 'Run24Hrs - รายการสั่งซื้อของฉัน'
  }

  handlePaginateChange = (offset) => {
    this.setState({
      showOrders: this.state.order.slice((offset - 1) * 5, offset * 5),
    })
  }

  render() {
    return (
      <div className="ui one column stackable centered grid">
        <div className="column">
          <div className="ui section divider" />
        </div>
        {this.state.showOrders.map((each) => (
          <div className="column">
            <OrderCard order={each} />
            <MobileOrderCard order={each} />
          </div>
        ))}
        <Pagination
          style={{ textAlign: 'center', marginBottom: 10 }}
          defaultCurrent={1}
          defaultPageSize={5}
          total={this.state.orders.length}
          onChange={(pageXOffset, _) => this.handlePaginateChange(pageXOffset)}
        />
        <RequireLogin />
      </div>
    )
  }
}

export default MyOrder



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/MyOrder.js